import { render, staticRenderFns } from "./IndexOrderDetail.vue?vue&type=template&id=8638239a&scoped=true"
import script from "./IndexOrderDetail.vue?vue&type=script&lang=js"
export * from "./IndexOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./IndexOrderDetail.vue?vue&type=style&index=0&id=8638239a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8638239a",
  null
  
)

export default component.exports